(function configDarkModeButton() {
	var localKey = 'dark-mode-enabled'
	var checks = [
		document.getElementById('ms-check-mobile'),
		document.getElementById('ms-check')
	].filter(Boolean)

	function setDarkMode(darkMode, toSave) {
		if (darkMode) document.documentElement.classList.add('dark-mode')
		else document.documentElement.classList.remove('dark-mode')
		checks.forEach(function (elm) {
			if (elm.checked !== darkMode) elm.checked = darkMode
		})

		if (toSave) localStorage.setItem(localKey, JSON.stringify(darkMode))
	}

	checks.forEach(
		function (btn) {
			btn.addEventListener('change', function () {
				setDarkMode(!!this.checked, true)
			})
		}
	)

	var localConfig
	try {
		localConfig = JSON.parse(localStorage.getItem(localKey))
	} catch (e) {
	}

	if (
		typeof localConfig === 'undefined' || localConfig === null
			? window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
			: localConfig
	) setDarkMode(true, false)
})()
